export enum OwnershipType {
    SingleOwner = 1,
    MultipleOwners = 2,
}

export const OwnershipTypes = [
    {
        id: OwnershipType.SingleOwner,
        name: 'Single Owner',
    },
    {
        id: OwnershipType.MultipleOwners,
        name: 'Multiple Owners',
    },
];

export const OwnershipTypeOptions = {
    [OwnershipType.SingleOwner]: 'Single Owner',
    [OwnershipType.MultipleOwners]: 'Multiple Owners',
};
